export interface StringField {field: string, label: string, defaultValue: string, type: 'string'}
export interface OptionsField {field: string, label: string, defaultValue: string, type: 'options', options: string[]}
export interface BooleanField {field: string, label: string, defaultValue: boolean, type: 'boolean'}
export interface NumericField {field: string, label: string, defaultValue: number, type: 'numeric'}
export interface DateField {field: string, label: string, defaultValue: 'today'|'future'|'past', type: 'date'}
export const availableConditionFieldsByTriggerType: {[key: string]: (StringField|BooleanField|OptionsField|NumericField|DateField)[]} = {
  'contract_start': [
    {
      field: 'role',
      type: 'options',
      label: 'Type',
      options: ['employee', 'client', 'client_contact'],
      defaultValue: 'employee',
    },
  ],
  'calendar_week': [
    {
      field: 'role',
      type: 'options',
      label: 'Type',
      options: ['employee', 'client', 'client_contact'],
      defaultValue: 'employee',
    },
    {
      field: 'contract_start',
      type: 'date',
      label: 'Startdatum contract',
      defaultValue: 'past',
    },
  ]
}